export const shouldShowBillingModal = ({ role, progress }) =>
  role === 'client' && progress.module > 0 && !progress.subscription;



// WEBPACK FOOTER //
// ./src/containers/Billing/utils.js